import { ExpenseTimeLineTypes } from '../../../../../types/ExpenseManagement/ExpenseList/ExpensesTimeLine/expensesTimeLineTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../utils/apiUtils'
import { AllowedHttpMethods, expensesTimeLineApiConfig } from '../../../apiList'

const getExpenseFormTimeline = async (
  formId: number,
): Promise<ExpenseTimeLineTypes[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: expensesTimeLineApiConfig.getExpenseAudit,
    method: AllowedHttpMethods.get,
    params: {
      formId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const expenseTimeLineApi = {
  getExpenseFormTimeline,
}
export default expenseTimeLineApi
